import axios from 'axios';
import refreshToken from './authService';
import Cookies from 'js-cookie';

const API_URL = process.env.REACT_APP_API_URL;

let cancelTokenSource = null;

const apiRequest = async (method, endpoint, data = null, params = null) => {
    if (cancelTokenSource) {
        cancelTokenSource.cancel('Operation canceled due to new request.');
    }
    cancelTokenSource = axios.CancelToken.source();

    try {
        const accessToken = Cookies.get('access_token');
        const headers = {
            Authorization: `Bearer ${accessToken}`,
            "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
        };

        const config = {
            method : method,
            url    : `${API_URL}${endpoint}`,
            headers: headers,
            params : params,
            data   : data,
            cancelToken: cancelTokenSource.token
        };

        const response = await axios(config);
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) {
            console.log('Request canceled:', error.message);
        } else if (error.response && error.response.status === 401) {
            try {
                const refreshTokenValue = Cookies.get('refresh_token');
                const newAccessToken = await refreshToken(refreshTokenValue);

                if (newAccessToken) {
                    Cookies.set('access_token', newAccessToken);
                    const headers = {
                        Authorization: `Bearer ${newAccessToken}`
                    };
                    const config = {
                        method : method,
                        url    : `${API_URL}${endpoint}`,
                        headers: headers,
                        params : params,
                        data   : data,
                        cancelToken: cancelTokenSource.token
                    };
                    const response = await axios(config);
                    return response.data;
                } else {
                    Cookies.remove('access_token');
                    Cookies.remove('refresh_token');
                    Cookies.remove('user_details');
                }
            } catch (refreshError) {
                console.error('Error refreshing token:', refreshError);
                Cookies.remove('access_token');
                Cookies.remove('refresh_token');
                Cookies.remove('user_details');

                throw refreshError;
            }
        } else {
            console.error('Error making API request:', error);
            throw error;
        }
    }
};

export default apiRequest;
